import ENVCONFIG from '@env'

const UnAuthorized = () => (window.location.href = `${ENVCONFIG.loginPage}`)

export default UnAuthorized
